import QRCode from "qrcode.react";

import { LocalLoadingSpinner } from "@/components/Layout/LoadingSpinner/LoadingSpinner";

export const TwoFactorChangeAuthQRCode = ({
  qrCodeData,
}: {
  qrCodeData: string | undefined;
}) => {
  if (!qrCodeData) {
    return (
      <div className="flex h-full w-full items-center justify-center">
        <LocalLoadingSpinner />
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center rounded-md bg-background-primary p-4">
      <QRCode value={qrCodeData} size={180} fgColor="#311123" />
    </div>
  );
};
